<template>
    <div class="w-full flex flex-col gap-4 items-center p-5">
        <div v-if="!showSuccess" class="white-rounded-box w-1/2 mx-auto p-7">
            <h1 class="pb-2.5">Create An Organization</h1>
            <hr />
            <p class="pt-2">
                Create an organization to create a place where your associated
                pros can be listed as well as news regarding your organization
            </p>

            <div class="mb-4 flex flex-col">
                <!-- single contact invite -->
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <form @submit.prevent="submitOrg">
                        <ValidationProvider
                            class="flex flex-col"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <span class="mt-2 flex flex-col">
                                Organization's Legal Name
                                <t-input v-model="formData.name" required />
                            </span>
                            <span class="mt-2 flex flex-col">
                                Doing Business As (Optional)
                                <t-input v-model="formData.dba" />
                            </span>
                            <span>
                                Brief Description (will be shown on organization page)
                                <t-input
                                    v-model="formData.description"
                                    placeholder="description of Organization"
                                    />
                            </span>
                            <span class="my-2 flex flex-col">
                                Address
                                <t-input
                                    v-model="formData.address"
                                    placeholder=""
                                    required
                                />
                            </span>
                            <span class="my-2 flex flex-col">
                                Primary Phone Number
                                <t-input
                                    v-model="formData.phone"
                                    placeholder="##########"
                                    required
                                    type="tel"
                                    pattern="[0-9]{10}"
                                    title="Please enter a valid phone number ex: 1234567890"
                                />
                            </span>
                            <span class="my-2 flex flex-col">
                                Domain
                                <t-input
                                    v-model="formData.domain"
                                    placeholder=""
                                    required
                                    title="Please enter a valid domain name ex: salesium.com"
                                    pattern="(\w+\.)(\w+)"
                                />
                            </span>
                            <p class="pt-2">
                                Please enter your domain without "https" or "www", example: salesium.com
                            </p>
                            <span class="my-2 flex flex-col">
                                Primary Email
                                <t-input
                                    v-model="formData.email"
                                    required
                                    type="email"
                                />
                            </span>
                            <p class="pt-2">
                                Please enter email with the same domain as your organization domain above, example: org@salesium.com
                            </p>
                        </ValidationProvider>
                        <div class="flex">
                            <button
                                class="px-10 py-3 my-3 rounded-lg bg-salesium-blue text-white"
                                type="submit"
                                :disabled="invalid||submitting"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </ValidationObserver>
                <t-alert variant="danger" :show="showError" class="mt-3">
                    {{ errorMessage }}
                </t-alert>
            </div>
        </div>
        <div v-else class="white-rounded-box w-1/2 mx-auto p-7">
            <t-alert variant="success" class="mt-3" :show="true" :dismissible="false">
                <p>Your organization has been submitted for review.</p>
                <a href="/"><p>Return to dashboard</p></a>
            </t-alert>
        </div>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
    data() {
        return {
            formData: {
                name: "",
                dba: "",
                address: "",
                phone: "",
                email: "",
                domain: "",
            },
            errorMessage: "",
            showError: false,
            showSuccess: false,
            submitting: false,
        };
    },
    methods: {
        submitOrg() {
            this.submitting = true;
            axios
                .post("/api/organizations/create", this.formData)
                .then((response) => {
                    // window.location.href = "/";
                    this.showSuccess = true;
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.showError = true;
                });
        },
    },
    props: ["user"],
    components: {
        ValidationObserver,
        ValidationProvider,
    },
};
</script>
